var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSendArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.683 6.47056L0.864958 0.0615336C0.764494 0.0112907 0.651648 -0.00884053 0.540008 0.00356394C0.428368 0.0159684 0.322693 0.0603797 0.235708 0.13145C0.152638 0.201071 0.0906346 0.292484 0.0566685 0.395411C0.0227024 0.498339 0.0181203 0.608701 0.0434371 0.714089L1.58743 6.40648H8.17708V7.57175H1.58743L0.0201316 13.2467C-0.00362467 13.3347 -0.00639775 13.427 0.0120354 13.5163C0.0304685 13.6056 0.0695937 13.6893 0.126265 13.7607C0.182935 13.8321 0.255571 13.8892 0.33833 13.9274C0.42109 13.9657 0.511664 13.9839 0.602771 13.9808C0.693978 13.9802 0.783784 13.9583 0.864958 13.9167L13.683 7.50766C13.7785 7.45877 13.8586 7.38449 13.9145 7.29299C13.9704 7.2015 14 7.09635 14 6.98911C14 6.88188 13.9704 6.77673 13.9145 6.68524C13.8586 6.59374 13.7785 6.51946 13.683 6.47056Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSendArrow);
export default __webpack_public_path__ + "static/media/sendArrow.0be6ceb4d1ba2e3eb4f9cec102d62578.svg";
export { ForwardRef as ReactComponent };